import React from "react";

import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import LocationOnOutlinedIcon from "@material-ui/icons/LocationOnOutlined";

const Post = ({ image, text, date, location, type, comments }) => {
  return (
    <div className='group text-gray-300'>
      <div className='flex flex-col'>
        <img
          className='w-full h-64 object-cover bg-center bg-no-repeat'
          src={image}
          alt=''
        />
        <div className='flex justify-between mt-1 px-3  border-b-2 font-serif border-gray-300'>
          <span
            className={`${
              type === "Found" || type === "News"
                ? "text-green-600"
                : "text-red-600"
            } font-bold`}>
            {type}{" "}
          </span>
          <span className='group-hover:text-white'>views (0)</span>
          <span className='group-hover:text-white'>
            Comments ({comments ? comments.length : "0"})
          </span>
        </div>
      </div>
      <div className='flex flex-col'>
        <p className=' px-2 mt-1 truncate max-w-xs group-hover:text-white'>
          <span className='font-bold font-mono text-white'>Title: </span>
          {text}
        </p>
        <div className='flex justify-between px-2 '>
          <div className='mt-2'>
            <DateRangeOutlinedIcon />
            <span className='ml-1 text-white font-semibold'>Date:</span>
          </div>
          <p className='group-hover:text-white'>{date}</p>
        </div>
        <div className='flex justify-between px-2 mt-2'>
          <div className='whitespace-nowrap'>
            <LocationOnOutlinedIcon />
            <span className='ml-1 text-white font-semibold'>Location:</span>
          </div>
          <p className='truncate max-w-xs group-hover:text-white'>{location}</p>
        </div>
      </div>
    </div>
  );
};

export default Post;
